// «↺ ↻» — отмена и возврат своих правок; общие для четырёх вкладок верхней строки
// («Этажи», «Работы», «Планирование», «Отчёты»), слева от вкладок (владелец 2026-10-17).
// Раньше жили в шапке «Модели ГПР». Что отменяется — решает журнал сервера (edits_lib.py):
// подсказка на стрелке называет действие, после отмены экран перечитывается.
import { useCallback, useEffect, useState } from 'react';
import { call, p, type Data } from './api';
import type { ShellCtx } from './shell';

type UndoState = Data<'/api/projects/{pid}/undo/state', 'get'>;
type UndoRes = Data<'/api/projects/{pid}/undo', 'post'>;
/** событие «правка сохранена» — стрелки перечитывают, что можно отменить */
export const OTMENA_OBNOVIT = 'plot-otmena';

export function Otmena({ ctx }: { ctx: ShellCtx }) {
  const [undo, setUndo] = useState<UndoState | null>(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    const r = await call<UndoState>('get', p('/api/projects/{pid}/undo/state', { pid: ctx.pid }));
    if (r.ok) setUndo(r.data);
  }, [ctx.pid]);
  useEffect(() => { void load(); }, [load, ctx.reloadToken]);
  useEffect(() => {
    const f = () => { void load(); };
    window.addEventListener(OTMENA_OBNOVIT, f);
    return () => window.removeEventListener(OTMENA_OBNOVIT, f);
  }, [load]);

  async function shag(napravlenie: 'undo' | 'redo') {
    setBusy(true);
    const r = await call<UndoRes>('post', p('/api/projects/{pid}/' + napravlenie, { pid: ctx.pid }), {});
    setBusy(false);
    if (!r.ok) { ctx.onError?.(r.error.message); return; }
    ctx.onError?.('');
    setUndo(r.data);
    ctx.onSaved?.((napravlenie === 'undo' ? 'Отменено: ' : 'Возвращено: ')
      + (r.data.sdelano || '') + ' (строк: ' + r.data.zadach
      + '). Нажмите «Пересчитать» в «Планировании», чтобы пересчитать даты.');
    ctx.onChanged?.();
  }

  return (
    <span className="pv-und">
      <button className="sec und" disabled={busy || !undo?.mozhno_otmenit}
        title={undo?.mozhno_otmenit
          ? 'Отменить последнее своё действие: ' + (undo.opisanie || '')
          : 'Отменять нечего (отменяются свои правки задач, работ, этажей и корпусов, удаление ручных задач и отметки факта, до 10 шагов)'}
        onClick={() => void shag('undo')}>↺</button>
      <button className="sec und" disabled={busy || !undo?.mozhno_povtorit}
        title={undo?.mozhno_povtorit ? 'Вернуть отменённое: ' + (undo.opisanie_povtora || '') : 'Возвращать нечего'}
        onClick={() => void shag('redo')}>↻</button>
    </span>
  );
}
